export default {
  id: 'RegistrationTable',
  code: 'CN',
  text: {
    'Proceed to transfer student?': '确认转为学员？',
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/RegistrationTable/locale.js